import { nullable2undefinable } from 'core/utils/commonUtils';
import { http } from 'core/utils/httpClient';
import type { GetOrderActionsNoDateRequest } from './dtoModels/order/getOrderActionsNoDateRequest';
import type { GetOrderActionsLogRequest } from './dtoModels/orderActionLog/getOrderActionsLogRequest';
import type { OrderActionsLogResponse } from './dtoModels/orderActionLog/orderActionsLogResponse';
import type { PaginatedList } from './dtoModels/paginatedList';
import type { Paginator } from './dtoModels/paginator';
import type { OrderActionsLog } from 'models/orderActionsLog';

export const mapOrderActionsLogs = (
  source: OrderActionsLogResponse[]
): OrderActionsLog[] => source.map((s) => mapOrderActionsLog(s));

export const mapOrderActionsLog = (source: OrderActionsLogResponse): OrderActionsLog => ({
  ...source,
  dateAction: nullable2undefinable(source.dateAction, (d) => new Date(d)),
  dateCreate: new Date(source.dateCreate),
  user: nullable2undefinable(source.user),
  order: {
    ...source.order,
    dateCreate: new Date(source.order.dateCreate),
  },
});

export async function getOrderActionsLogAsync(
  request: GetOrderActionsLogRequest
): Promise<OrderActionsLog[]> {
  const { data } = await http.get<OrderActionsLogResponse[]>('order-actions', {
    params: request,
  });

  return mapOrderActionsLogs(data);
}

export async function getOrderActionsNoDateAsync(
  request: GetOrderActionsNoDateRequest & Paginator
): Promise<PaginatedList<OrderActionsLog>> {
  const { data } = await http.get<PaginatedList<OrderActionsLogResponse>>(
    'order-actions/no-date',
    {
      params: request,
    }
  );

  return { ...data, items: mapOrderActionsLogs(data.items) };
}
